"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = addVersion;

var _botframeworkWebchatComponent = require("botframework-webchat-component");

var _botframeworkWebchatCore = require("botframework-webchat-core");
/* global global:readonly, VERSION:readonly */

/* eslint no-empty: ["error", { "allowEmptyCatch": true }] */


function setMetaTag(name, content) {
  try {
    var _global = global,
        document = _global.document;

    if (typeof document !== 'undefined' && document.createElement && document.head && document.head.appendChild) {
      var meta = document.querySelector("html meta[name=\"".concat(encodeURI(name), "\"]")) || document.createElement('meta');
      meta.setAttribute('name', name);
      meta.setAttribute('content', content);
      document.head.appendChild(meta);
    }
  } catch (err) {}
}

function addVersion(variant) {
  setMetaTag('botframework-webchat:bundle:variant', variant);
  setMetaTag('botframework-webchat:bundle:version', "4.5.0");
  setMetaTag('botframework-webchat:core:version', _botframeworkWebchatCore.version);
  setMetaTag('botframework-webchat:ui:version', _botframeworkWebchatComponent.version);
}